<template>
  <section>
    <div class="grid gap-4 xl:grid-cols-4 md:grid-cols-3 mb-8" v-if="data">
      <div v-for="d in data" :key="d.id">
        <div
          class="p-4 lg:w-full shadow-lg border-1 border-borderColor rounded-lg space-y-1 bg-gray-lightest duration-500 shadow-all"
        >
          <div class="">
            <div class="flex justify-between mb-2">
              <p class="text-gray-light font-semibold text-md text-base">
                {{ getFormattedDate(d.start_date, d.timezone, 'MMM DD, YYYY') }}
              </p>
              <span class="text-xs" v-if="d.is_private">
                <img
                  :src="require(`@/assets/svg/lock.png`)"
                  alt=""
                  class="w-6 h-6 rounded-full text-white filter-gray"
                />
              </span>
            </div>
            <div class="flex justify-between items-center mb-2">
              <p class="text-gray-dark font-bold text-xl">
                {{ getFormattedDate(d.start_date, d.timezone, 'dddd') }}
              </p>
            </div>

            <div class="flex mb-4">
              <p class="text-gray-dark md:text-md text-md text-base">
                {{ getFormattedDate(d.start_date, d.timezone, 'h:mm A') }} -
                {{ getFormattedDate(d.end_date, d.timezone, 'h:mm A') }}
                <!-- <span class="text-xs">{{ getTimeZone() }}</span> -->
              </p>
            </div>
          </div>

          <div class="flex justify-between items-center">
            <div class="bg-blue-light rounded-lg">
              <p class="text-gray-light lg:text-md text-xs lg:px-6 px-2 py-2">
                {{ d.total_subscribed_users }} Subscribers
              </p>
            </div>
            <button
              v-if="d.start_meeting_link"
              @click="beginSessionHandler(d.start_meeting_link)"
            >
              <div
                class="bg-green-light px-2 py-1 flex items-center text-white rounded-lg animate__animated"
              >
                <span class="text-white mr-1 text-xs"> Go to live </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "SessionBatchCard",
  props: {
    data: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions(["postTrainerLivestreamAuth"]),

    async onclickStartClass(link, id) {
      if (link) {
        window.open(link);

        await this.postTrainerLivestreamAuth({
          batch_id: id,
        });
      }
    },
    beginSessionHandler (meetLink) {
      meetLink && meetLink.length ? window.open(meetLink, '_blank') : this.$store.commit('setError', {title: "Alert", text: 'Session Link Un-available'})
    }
  },
};
</script>